import React, { useState, useEffect, Suspense, lazy} from "react"
import {graphql, useStaticQuery} from 'gatsby'
import { HelmetDatoCms } from "gatsby-source-datocms";
import Loader from "react-loader-spinner";
import useHotjar from 'react-use-hotjar';
import Popup from "../components/sections/popup";

import Layout from "../components/layout"
const Header = lazy(() =>import('../components/header'));
const Intro = lazy(() =>import('../components/sections/intro'));
const Datos = lazy(() =>import('../components/sections/datos'));
const Experienciarte = lazy(() =>import('../components/sections/experienciarte'));
const ArteProyectos = lazy(() =>import('../components/proyectos/arteProyectos'));
const AinternacionalProyectos = lazy(() =>import('../components/proyectos/ainternacionalProyectos'));
const PlanEstudios = lazy(() =>import('../components/sections/planEstudios'));
const Claustro = lazy(() =>import('../components/sections/claustro'));
const ComoAplicar = lazy(() =>import('../components/sections/comoAplicar'));
const PreguntasFrecuentes = lazy(() =>import('../components/sections/preguntasFrecuentes'));
const Campus = lazy(() =>import('../components/sections/campus'));
const CallToAction = lazy(() =>import('../components/ui/callToAction'));


const myCustomLogger = console.info;

const Arte = () => {

    const { initHotjar } = useHotjar();

    const [isLoading, setIsLoading] = useState(true)
    useEffect(() => {        
        initHotjar(2496136, 6, false, myCustomLogger);        
        setTimeout(() => {
            setIsLoading(false);
          }, 1000);          
    }, [initHotjar])

    const dataProgram = useStaticQuery(graphql`
    query {
        allDatoCmsPosgrado(filter: { nombre: { eq: "m-arte" } }){    
          nodes{
                nombre
                coverImage {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  }  
                titulo {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }                
                principales {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }  
                introduccion {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                } 
                trata {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                } 
                porque {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }
                aQuien {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }
                talentoimg1 {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  }  
                talento1 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }  
                talentourl1
                talentoimg2 {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  }  
                talento2 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }
                talentourl2
                talentoimg3 {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  }     
                talento3 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }   
                talentourl3
                talentoimg4 {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  }        
                talento4 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }      
                talentourl4                                                   
                semestre1 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                } 
                semestre2 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }  
                semestre3 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }
                estudiosimg1 {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  } 
                  estudiosimg2 {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  } 
                  pdf  
                  claustro1 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }  
                claustro2 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }    
                claustro3 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }      
                claustro4 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }      
                claustro5 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }     
                claustro6 {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }                                                                                                                                        
                requisitos {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }  
                campus {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }
                sustentableImagen {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  } 
                urlInstalaciones
                campusImagen {
                fluid(
                    imgixParams: { fm: "jpg" }
                    sizes: "(max-width: 1500px) 100vw, 1500px"
                ) {
                    ...GatsbyDatoCmsFluid
                }
                }
                linkcta   
                whatsapp {
                    value
                    blocks {
                            __typename
                            ... on DatoCmsImageBlock {
                            id: originalId
                            image {
                                fluid(
                                imgixParams: { fm: "jpg" }
                                sizes: "(max-width: 700) 100vw, 700px"
                                ) {
                                ...GatsbyDatoCmsFluid
                                }
                            }
                        }
                    }
                }
                activoPopup
                popup {
                    fluid(
                      imgixParams: { fm: "jpg" }
                      sizes: "(max-width: 1500px) 100vw, 1500px"
                    ) {
                      ...GatsbyDatoCmsFluid
                    }
                  }    
                linkPopup
                seoMetaTags {
                    ...GatsbyDatoCmsSeoMetaTags
                }                                                       
            }  
        }
    }
       
    `)
    //Obtener elementos de consulta
    //console.log(dataProgram.allDatoCmsPosgrado.nodes[0]);
    const { 
        nombre, coverImage, titulo, principales, introduccion, 
        trata, porque, aQuien, 
        talentoimg1, talento1, talentourl1, talentoimg2, talento2, talentourl2, talentoimg3, talento3, talentourl3, talentoimg4, talento4, talentourl4,
        semestre1, semestre2, semestre3, estudiosimg1, estudiosimg2, pdf,
        claustro1, claustro2, claustro3, claustro4, claustro5, claustro6, 
        requisitos, 
        campus, sustentableImagen, urlInstalaciones, campusImagen,
        linkcta, whatsapp, activoPopup, popup, linkPopup,
        seoMetaTags } = dataProgram.allDatoCmsPosgrado.nodes[0];
    //console.log( estudiosimg1, estudiosimg2);
    //Variables y constantes adicionales
    let urlButton ="/m-arte#aplicar"

    return ( 
        isLoading ?       
        <div 
            style={{                            
            display: "flex",
            justifyContent: "center",
            alignItems: "center"              
            }}
        >
            <Loader    
                style={{                            
                    position: "fixed",      
                    top: "40%"
                }}
                type="Puff"
                color="#5a5c61"
                height={100}
                width={100}
                timeout={1000} //3 secs
            />
        </div> :
        <Layout>
            <HelmetDatoCms seo={seoMetaTags}/>
            <Suspense fallback={ <p></p>}>
                <Header
                    nombre={nombre}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <Intro
                    nombre={nombre}
                    urlButton={urlButton}
                    coverImage={coverImage}
                    titulo={titulo}
                    principales={principales}
                    introduccion={introduccion}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <Datos
                    datosTrata={trata}
                    datosPorque={porque}
                    datosQuien={aQuien}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <Experienciarte
                    talentoimg1={talentoimg1}
                    talento1={talento1}
                    talentourl1={talentourl1}
                    talentoimg2={talentoimg2}
                    talento2={talento2}
                    talentourl2={talentourl2}
                    talentoimg3={talentoimg3}
                    talento3={talento3}
                    talentourl3={talentourl3}
                    talentoimg4={talentoimg4}
                    talento4={talento4}
                    talentourl4={talentourl4}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <ArteProyectos/>
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <PlanEstudios
                    nombre={nombre}
                    semestre1={semestre1}
                    semestre2={semestre2}
                    semestre3={semestre3}
                    estudiosimg1={estudiosimg1}
                    estudiosimg2={estudiosimg2}
                    pdf={pdf}
                />
            </Suspense>
             <Suspense fallback={ <p></p>}>
            <AinternacionalProyectos/>
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <Claustro
                    nombre={nombre}
                    claustro1={claustro1}
                    claustro2={claustro2}
                    claustro3={claustro3}
                    claustro4={claustro4}
                    claustro5={claustro5}
                    claustro6={claustro6}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <ComoAplicar 
                    nombre={nombre}
                    requisitos={requisitos}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <PreguntasFrecuentes/>
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <Campus
                    campus={campus}
                    sustentableImagen={sustentableImagen}
                    urlInstalaciones={urlInstalaciones}
                    campusImagen={campusImagen}
                />
            </Suspense>
            <Suspense fallback={ <p></p>}>
                <CallToAction 
                    nombre={nombre}
                    linkcta={linkcta}
                    whatsapp={whatsapp}
                />
            </Suspense>
          { activoPopup ? 
              <Popup
                popup={popup}
                linkPopup={linkPopup}
              />           
           : null }
        </Layout>
     );
}
 
export default Arte;
